export default __webpack_public_path__ + "static/media/gifv2.e9e42b09.gif";